






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GQL_PaycheckPeriodSave } from '@/queries/global';
import { range } from 'lodash';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '../../queries/Application';
import { GQL_currentUnit_currentUnit } from '../../queries/__generated__/currentUnit';

@Component
export default class PaycheckPeriodsGenerateForm extends Vue {
  @Prop({ type: Number, required: true }) private year!: number;

  @SmartQuery(CURRENT_UNIT) private currentUnit!: GQL_currentUnit_currentUnit;

  private strictlyMonthlyPeriods = true;

  @Emit('periods-generated')
  private generateMonthlyPeriods(): GQL_PaycheckPeriodSave[] {
    return range(1, 13).map(month => {
      const bookkeepingPeriod = `${this.year}-${String(month).padStart(2, '0')}`;
      const monthMoment = this.$dayjs.strict(`${bookkeepingPeriod}-01`);

      return {
        id: null,
        name: this.$t(`MonthNames.${month}`, this.currentUnit.locale) as string,
        bookkeepingPeriod,
        startDate: monthMoment.startOf('month').format('YYYY-MM-DD'),
        endDate: monthMoment.endOf('month').format('YYYY-MM-DD'),
        journalDate: monthMoment.endOf('month').format('YYYY-MM-DD'),
      };
    });
  }
}
